import api from "@/api";
import { catcher } from "@/api/handleError";
import { block } from "./endpoints";

export default {
  getPage(page = 1) {
    return api()
      .get(block.getPage, { params: { page }})
      .catch(catcher);
  },
  getAll() {
    return api()
      .get(block.getAll)
      .catch(catcher);
  },
  getOne(id) {
    return api()
      .get(block.getOne(id))
      .catch(catcher);
  },
  update(id, data) {
    return api()
      .put(block.update(id), data)
      .catch(catcher);
  },
  create(data) {
    return api()
      .post(block.create, data)
      .catch(catcher);
  },
  delete(id) {
    return api()
      .delete(block.delete(id))
      .catch(catcher);
  },
  getBlockTags() {
    return api()
      .get(block.getTags)
      .catch(catcher);
  },
};
